import React, { useEffect } from 'react';
import "./_loginscreen.scss";
import { useDispatch, useSelector} from 'react-redux';
import { login } from '../../redux/actions/auth.action'
import { useHistory } from 'react-router-dom';

function LoginScreen() {
       
   const dispatch  = useDispatch()

   const accessToken = useSelector(state => state.auth.accessToken)
   const handleLogin = () => {
      dispatch(login())
   }

    const history = useHistory();

    useEffect(() => {
       if(accessToken){
          history.push('/');
       }
    }, [accessToken, history]);

    return (
        <div className='login'>
         <div className='login__container'>
            <h2>Youtube Clone</h2>
            <img
               src='http://pngimg.com/uploads/youtube/youtube_PNG2.png'
               alt=''
            />
            <button onClick= {handleLogin}>Login With google</button>
            <p>This Project is made using YOUTUBE DATA API</p>
         </div>
      </div>
    )
}

export default LoginScreen;
